// Boleto da parceira (Gran) sem o PDF unificado.
//
// Por que existe: em 20/10/2026 a fatura 14510 (UC 412834801262, OUT/2026) foi
// emitida no Asaas, mas o PDF unificado não saiu — o login do Supabase levou 30 s
// para responder, estourou o tempo, e a `gerar-boleto-gran` devolveu 401. A tela de
// emissão só mostrou um aviso e seguiu: a fatura ficou "A enviar" só com o link do
// Asaas, o "Visualizar Boleto / PDF" abria o Asaas no lugar do boleto unificado e o
// envio sairia sem o `token_boleto_publico` (que só nasce junto com o PDF).
//
// Puro (sem I/O) para rodar sob `node --test`.

export type FaturaPdfUnificado = {
    empresa_parceira_id?: string | null;
    url_boleto?: string | null;
    pdf_boleto_combinado?: string | null;
    ambiente?: string | null;
};

/**
 * Cobrança da parceira já criada no Asaas, mas sem o PDF unificado.
 *
 * Vale para toda fatura de parceira: as 79 UCs da Gran são de boleto único
 * (conferido em 20/10/2026) e, desde agosto, 168 das 169 cobranças têm o PDF — a
 * que faltava é a do caso acima. Boleto de teste fica de fora, como em `pdfPerdido`.
 */
export function faltaPdfUnificado(f: FaturaPdfUnificado | null | undefined): boolean {
    return !!f
        && !!f.empresa_parceira_id
        && !!f.url_boleto
        && !f.pdf_boleto_combinado
        && f.ambiente !== 'sandbox';
}

/** Tentativas totais de gerar o PDF (a primeira + as repetições). */
export const TENTATIVAS_PDF_UNIFICADO = 3;

/** Espera antes de cada repetição, em ms. */
export const ESPERAS_PDF_UNIFICADO_MS = [3000, 8000];

/**
 * Falha que costuma sumir tentando de novo: banco ou login lentos.
 *
 * - `undefined`: nem chegou resposta (rede).
 * - 401: é o que a function devolve quando o login não responde a tempo (o
 *   `getUser` estoura em 30 s e volta sem usuário). Sessão vencida de verdade
 *   também dá 401; repetir só custa mais duas tentativas.
 * - 408, 429 e 5xx: tempo esgotado, excesso de chamadas, erro do servidor.
 *
 * 400, 403 e 404 são regra (PDF da Equatorial ainda espelho, sem permissão,
 * fatura inexistente): repetir não muda a resposta.
 */
export function falhaPassageira(status: number | undefined): boolean {
    if (status === undefined) return true;
    return status === 401 || status === 408 || status === 429 || status >= 500;
}
